// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__cyMs1","indicator":"Checkbox_indicator__Mb2SO"};